import iframeResizer from 'iframe-resizer';
var iframes = iFrameResize({
  log: false,
  enablePublicMethods     : true,                  // Enable methods within iframe hosted page
  autoResize: true,
  checkOrigin: false,
  sizeHeight: true,
  sizeWidth: false,
}, '#dienstplan');
